module.exports = __webpack_public_path__ + "static/media/image-interval-training@2x.48d97b81.png";